// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Snex1SecurityCell{height:100%;padding:0px}.Snex1SecurityCell a{display:flex;padding:16px}", ""]);
// Exports
module.exports = exports;
